export default __webpack_public_path__ + "static/media/provider-newsletter.d520ee7b.png";